import { Grid, Typography } from "@material-ui/core";
import classNames from "classnames";
import { memo } from "react";
import { toDateString } from "utils/to-date";
import { useStyles } from "./data-versao-styles";

export const DataVersao = memo(({ data, tipo }: { data: string, tipo: 'estavel' | 'beta' | 'alfa' }) => {

    const classes = useStyles();

    return (
        <Grid
            className={classNames(
                classes.dataLog,
                tipo === 'estavel'
                    ? classes.estavel
                    : tipo === 'beta'
                        ? classes.beta
                        : tipo === 'alfa'
                            ? classes.alfa
                            : ''
            )}
        >
            <Typography variant="caption">
                {tipo === "alfa"
                    ? "Alfa: "
                    : tipo === "beta"
                        ? "Beta: "
                        : tipo === "estavel"
                            ? "Produção: "
                            : ""}
                {data && typeof data === "string" && data.trim() !== ""
                    ? `${toDateString(data)}${(() => {
                        return (typeof data === "string" ? new Date(data) : data).getTime() > new Date().getTime() ? " (Prevista)" : "";
                    })()
                    }`
                    : "--"}
            </Typography>
        </Grid>
    )
});